import { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";
import { baseurl, imageUrl } from "../../Baseurl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Plus } from "react-feather";

function CreateChatRoom({ onCreateRoom }) {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [assignees, setAssignees] = useState([]);
  const [selectedAssignees, setSelectedAssignees] = useState([]);

  const [newRoom, setNewRoom] = useState({
    name: "",
    category: "",
    reference_id: "",
    participants: [],
  });

  const adminID = localStorage.getItem("adminID");

 


  useEffect(() => {
    if (adminID) {
      axios
        .get(`${baseurl}getAssigneesByOrgId/${adminID}`)
        .then((res) => {
          if (res.data?.assignees?.length) {
            const formatted = res.data.assignees.map((item) => ({
              label: item.full_name,
              value: item.id,
              profileImageUrl: item.profile_image
                ? `${imageUrl}assignee/${item.profile_image}`
                : null,
            }));
            setAssignees(formatted);
          }
        })
        .catch((err) => console.error("Failed to fetch assignees", err));
    }
  }, [adminID]);




 


const handleCreateRoom = async () => {
  if (!newRoom.name || !newRoom.category) return;

  const participants = selectedAssignees.map((a) => a.value);
  const created_by = localStorage.getItem("org_id");

  const finalRoomData = { ...newRoom, participants, created_by };

  console.log("Creating Room with Data:", finalRoomData);

  try {
    const response = await axios.post(`${baseurl}createChatRoom`, finalRoomData);

    if (response.data.success) {
      toast.success("Room created successfully!");
      onCreateRoom && onCreateRoom(finalRoomData); // Optional callback
    } else {
      toast.error(response.data.message || "Failed to create room.");
    }
  } catch (error) {
    console.error("Error creating room:", error);
    toast.error("An error occurred while creating the room.");
  }

  // Reset form
  setNewRoom({
    name: "",
    category: "",
    reference_id: "",
    participants: [],
  });
  setSelectedAssignees([]);
  setShowCreateModal(false);
};













  // Optional: Custom render for selected options
  const customSingleValue = ({ data }) => (
    <div className="d-flex align-items-center">
      {data.profileImageUrl && (
        <img
          src={data.profileImageUrl}
          alt={data.label}
          style={{ width: 24, height: 24, borderRadius: "50%", marginRight: 6 }}
        />
      )}
      <span>{data.label}</span>
    </div>
  );

  const customOption = (props) => {
    const { data, innerRef, innerProps } = props;
    return (
      <div ref={innerRef} {...innerProps} className="d-flex align-items-center p-2">
        {data.profileImageUrl && (
          <img
            src={data.profileImageUrl}
            alt={data.label}
            style={{ width: 24, height: 24, borderRadius: "50%", marginRight: 10 }}
          />
        )}
        <span>{data.label}</span>
      </div>
    );
  };

  return (
    <>
      {/* <button className="btn btn-primary mb-3" onClick={() => setShowCreateModal(true)}>
        + Create Room
      </button> */}

      <span className="createbh" onClick={() => setShowCreateModal(true)}>
        <Plus size={15} /> 
      </span>

      {showCreateModal && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
          onClick={() => setShowCreateModal(false)}
        >
          <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Create New Room</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowCreateModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label htmlFor="roomName" className="form-label">Room Name</label>
                  <input
                    type="text"
                    id="roomName"
                    className="form-control"
                    placeholder="Enter room name"
                    value={newRoom.name}
                    onChange={(e) => setNewRoom({ ...newRoom, name: e.target.value })}
                  />
                </div>

               <div className="mb-3">
  <label htmlFor="category" className="form-label">Category</label>
  <select
    id="category"
    className="form-control"
    value={newRoom.category}
    onChange={(e) => setNewRoom({ ...newRoom, category: e.target.value })}
  >
    <option value="">Select category</option>
    <option value="project">Project</option>
    <option value="strategic">Strategic</option>
    <option value="operation">Operation</option>
  </select>
</div>


                <div className="mb-3">
                  <label htmlFor="referenceId" className="form-label">Reference ID</label>
                  <input
                    type="text"
                    id="referenceId"
                    className="form-control"
                    placeholder="Reference ID"
                    value={newRoom.reference_id}
                    onChange={(e) => setNewRoom({ ...newRoom, reference_id: e.target.value })}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label text-start w-100">Users</label>
                  <Select
                    options={assignees}
                    value={selectedAssignees}
                    onChange={setSelectedAssignees}
                    getOptionLabel={(e) => e.label}
                    components={{ SingleValue: customSingleValue, Option: customOption }}
                    isMulti
                    className="w-100 text-start text-dark txt11lk"
                    placeholder="Select Users"
                  />
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowCreateModal(false)}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleCreateRoom}
                  disabled={!newRoom.name || !newRoom.category}
                >
                  Create Room
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CreateChatRoom;
